import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { PoliciesState } from './policies/types';
import policiesReducer from './policies/slices';
import { PlansState } from './plans/types';
import plansReducer from './plans/slices';
import { FaqsState } from './faqs/types';
import faqsReducer from './faqs/slices';
import { VouchersState } from './vouchers/types';
import vouchersReducer from './vouchers/slices';
import { GiftsState } from './gifts/types';
import giftsReducer from './gifts/slices';
import { ProductsState } from './products/types';
import productsReducer from './products/slices';
import { PromoCodesState } from './promoCodes/types';
import promoCodesReducer from './promoCodes/slices';
import { PromoCodeAliasesState } from './promoCodeAliases/types';
import promoCodeAliasesReducer from './promoCodeAliases/slices';
import { ProductGroupsState } from './productGroups/types';
import productGroupsReducer from './productGroups/slices';
import { BehaviourEventState } from './behaviourEvent';
import behaviourEventReducer from './behaviourEvent/slices';

export let productStore: StoreType<{
  policies: PoliciesState;
  plans: PlansState;
  faqs: FaqsState;
  vouchers: VouchersState;
  gifts: GiftsState;
  products: ProductsState;
  promoCodes: PromoCodesState;
  promoCodeAliases: PromoCodeAliasesState;
  productGroups: ProductGroupsState;
  behaviourEvent: BehaviourEventState;
}>;

// export type StoreType = typeof store;
export type ProductDispatch = typeof productStore.dispatch;
export type ProductStoreState = ReturnType<typeof productStore.getState>;
export const useProductDispatch = () => useDispatch<ProductDispatch>();
export const useProductSelector: TypedUseSelectorHook<ProductStoreState> =
  useSelector;
export const getProductState = (store: Store) =>
  store.getState() as ProductStoreState;

export const injectProductReducers: ReducersInjectorWithState<
  ProductStoreState
> = () => {
  return [
    {
      name: 'policies',
      reducer: policiesReducer,
    },
    {
      name: 'plans',
      reducer: plansReducer,
    },
    {
      name: 'faqs',
      reducer: faqsReducer,
    },
    { name: 'vouchers', reducer: vouchersReducer },
    { name: 'gifts', reducer: giftsReducer },
    { name: 'products', reducer: productsReducer },
    { name: 'promoCodes', reducer: promoCodesReducer },
    { name: 'promoCodeAliases', reducer: promoCodeAliasesReducer },
    {
      name: 'productGroups',
      reducer: productGroupsReducer,
    },
    {
      name: 'behaviourEvent',
      reducer: behaviourEventReducer,
    },
  ];
};
